import { Settings } from 'luxon';

import { Locale } from '@silae/composables';
import { DEFAULT_LOCALE, formatLocale } from '~/utils';

export function updateLuxonConfiguration(locale: Locale = DEFAULT_LOCALE) {
	Settings.defaultLocale = formatLocale(locale);
}
